var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 82,
    viewBox: "0 0 68 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.575 11.1441C42.2697 15.6462 50.6161 18.8452 59.0468 21.1461C59.1212 21.1664 59.1728 21.234 59.1728 21.3111V44.6259C59.1728 53.5106 50.2057 66.1794 34.575 72.1847",
    stroke: "#F4F4F9",
    strokeWidth: 3.07696,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.575 3C44.3833 8.69422 55.0455 12.7384 65.7924 15.6462C65.867 15.6664 65.9187 15.734 65.9187 15.8112V45.3023C65.9187 56.5275 54.4781 72.4126 34.575 80",
    stroke: "#F4F4F9",
    strokeWidth: 3.07696,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 11.1441C25.8124 15.6463 17.3846 18.8452 8.95307 21.1461C8.87865 21.1664 8.82707 21.234 8.82707 21.3111V44.6259C8.82707 53.5106 17.2183 66.1794 32.8491 72.1847",
    stroke: "#F4F4F9",
    strokeWidth: 3.07696,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 3C23.6988 8.69422 12.955 12.7384 2.20749 15.6462C2.13291 15.6664 2.08117 15.734 2.08117 15.8112V45.3023C2.08117 56.5275 12.9459 72.4126 32.8491 80",
    stroke: "#F4F4F9",
    strokeWidth: 3.07696,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5917 25.2952L26.0198 39.1365C25.9378 39.2094 25.9447 39.3394 26.0338 39.4033L31.8459 43.5658C31.9065 43.6092 31.932 43.6869 31.9089 43.7577L27.5467 57.1555C27.492 57.3236 27.6972 57.4541 27.8261 57.3332L42.9838 43.1233C43.0625 43.0495 43.054 42.9221 42.9661 42.8594L36.6653 38.3636C36.6005 38.3174 36.5762 38.2325 36.6067 38.159L41.8632 25.4885C41.9327 25.3208 41.7274 25.1746 41.5917 25.2952Z",
    stroke: "#F4F4F9",
    strokeWidth: 3.07696,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceProtection);
export default __webpack_public_path__ + "static/media/Insurance-Protection.2dffcb3202a499ef8a1ff603272c0f10.svg";
export { ForwardRef as ReactComponent };